import { NavLink } from 'react-router-dom'
import { LayoutDashboard, Kanban, Zap, UserPlus } from 'lucide-react'
import { useAuthStore } from '@/stores/authStore'
import { useEventLeadCaptureStore } from '@/stores/eventLeadCaptureStore'
import { canAccessRoute } from '@/config/routeAccess'

const navItems = [
  { icon: LayoutDashboard, label: 'Dashboard', to: '/dashboard' },
  { icon: Kanban, label: 'Deals', to: '/deals' },
  { icon: Zap, label: 'Carteira', to: '/closer-leads' },
] as const

export function BottomNavigation() {
  const user = useAuthStore((s) => s.user)
  const openQuickForm = useEventLeadCaptureStore((s) => s.openQuickForm)
  const canQuickLead = user ? canAccessRoute(user.role, '/closer-leads', user) : false

  return (
    <nav
      className='fixed bottom-0 left-0 right-0 z-40 md:hidden bg-bg-sidebar border-t border-white/[0.06]'
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className='flex items-center justify-around h-14'>
        {navItems.slice(0, 1).map(({ icon: Icon, label, to }) => (
          <NavLink key={to} to={to} end={to === '/dashboard'} className='flex-1'>
            {({ isActive }) => (
              <div className='flex flex-col items-center justify-center gap-1 py-2 min-h-[44px] min-w-[44px]'>
                <Icon
                  size={20}
                  strokeWidth={isActive ? 2 : 1.5}
                  className={isActive ? 'text-accent' : 'text-text-muted'}
                />
                <span
                  className={`text-[10px] font-medium leading-none ${
                    isActive ? 'text-accent' : 'text-text-muted'
                  }`}
                >
                  {label}
                </span>
              </div>
            )}
          </NavLink>
        ))}

        {canQuickLead ? (
          <button
            type='button'
            onClick={openQuickForm}
            className='flex-1'
            aria-label='Cadastro rápido de lead em evento'
          >
            <div className='flex flex-col items-center justify-center gap-1 py-2 min-h-[44px] min-w-[44px]'>
              <UserPlus size={20} strokeWidth={1.5} className='text-text-muted' />
              <span className='text-[10px] font-medium leading-none text-text-muted'>Cadastro</span>
            </div>
          </button>
        ) : null}

        {navItems.slice(1).map(({ icon: Icon, label, to }) => (
          <NavLink key={to} to={to} className='flex-1'>
            {({ isActive }) => (
              <div className='flex flex-col items-center justify-center gap-1 py-2 min-h-[44px] min-w-[44px]'>
                <Icon
                  size={20}
                  strokeWidth={isActive ? 2 : 1.5}
                  className={isActive ? 'text-accent' : 'text-text-muted'}
                />
                <span
                  className={`text-[10px] font-medium leading-none ${
                    isActive ? 'text-accent' : 'text-text-muted'
                  }`}
                >
                  {label}
                </span>
              </div>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
